import { InputAdornment, TextField } from "@mui/material";
import { forwardRef, useEffect, useState } from "react";
import { set, useController } from "react-hook-form";

const CustomPercentageField = forwardRef(({ field, control }, ref) => {
  const [focused, setFocused] = useState(false);
  const [error, setError] = useState(null);
  const { field: fieldProps, fieldState } = useController({
    control,
    name: field.name,
  });

  const formatValue = (val) => {
    if (isNaN(val)) return "";
    const reshapedValue = focused
      ? `${Math.round(val * 10000000000) / 100000000}`
      : (val * 100).toFixed(2);
    return reshapedValue.replace(".", ",");
  };

  const deformatValue = (val) => {
    let cleanValue = val.replace(/[^0-9.,]/g, "").replace(".", ",");
    let preparedValue = cleanValue.replace(",", ".");
    if (!isNaN(preparedValue)) {
      const value = parseFloat(preparedValue) / 100;
      return { value, cleanValue: cleanValue, error: null };
    }
    return { value: NaN, cleanValue, error: "Not a number." };
  };

  const [innerValue, setInnerValue] = useState(formatValue(fieldProps.value));

  useEffect(() => {
    setInnerValue(formatValue(fieldProps.value));
  }, [focused]);

  const handleChange = (e) => {
    setInnerValue(e.target.value);
    const { cleanValue, error, value } = deformatValue(e.target.value);
    if (!error) fieldProps.onChange(value);
    setError(error);
    setInnerValue(cleanValue);
  };

  const handleFocus = () => {
    setFocused(true);
  };

  // Lorsqu'on perd le focus, on revient à 2 décimales
  const handleBlur = (e) => {
    setFocused(false);
    const { value, error } = deformatValue(e.target.value);
    if (!error) fieldProps.onChange(value);
    else setInnerValue(formatValue(fieldProps.value));
    fieldProps.onBlur();
  };

  return (
    <TextField
      ref={ref}
      label={field.label}
      variant="outlined"
      fullWidth
      type={"text"}
      helperText={error || fieldProps.error || field.help_text || ""}
      disabled={field.disabled}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onChange={handleChange}
      value={innerValue}
      slotProps={{
        input: {
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        },
      }}
      error={!!error || !!fieldProps.error}
    />
  );
});

export default CustomPercentageField;
